__turbopack_context__.v({
  "className": "outfit_b4e8c25d-module__3BvbIG__className",
  "variable": "outfit_b4e8c25d-module__3BvbIG__variable",
});
